import {get,post,del} from '../utils/request'

// 获取省市区列表
export const adress = () => get('/api/province/list')

// 根据省市区获取学校列表
export const schoolList = (params) => get('/api//school/list/tree/all',params)

// 校长研修模块
// 校长随笔列表
export const informalEssay = (params) => get('/api/article-leader/page/school',params)

// 发布随笔接口
export const sendEssay = (data) => post('/api/article-leader/add',data)

// 校长随笔详情(公共接口)
export const essayDetail = (url,params) => get(url,params)

// 普通校、区县领导
// 所有校长工作简报列表
export const allJobBriefing = (params) => get('/api/article-leader/page/region/group',params)

// 个人工作简报列表
export const selfJobBriefing = (params) => get('/api/article-leader/page/region',params)

// 删除工作简报接口
export const editJobBriefing = (url,params) => del(url,params)

// 教师数据统计获取年级数据统计
export const gradeStatis = (params) => get('/api/statistics/list/school/page',params)

// 根据年级id获取教师年级列表
export const TableData = (params) => get('/api/statistics/list/school/page',params)

// 根据年级获取班级列表
export const gradeGetclass = (params) => get('/api/school-grade-class/list',params)

// 根据班级id获取科目
export const classesGetobject =(url,params) => get(url,params)

// 根据集团校id查询子校列表
export const findSchoolList = (params) => get('/api/school/list/tree/group',params)

// 集团校领导工作简报
export const groupJobBriefing = (params) => get('/api/article-leader/page/groupSchool',params)

// 根据学校id获取年级列表(普通校)
export const findGradeList = (params) => get('/api/school-grade/list',params)

// 根据学校id、省市区获取年级列表（集团校、省市区）
export const findGroupGradeList = (params) => get('/api/school-grade/list/group',params)



// WEBPACK FOOTER //
// ./src/api/leaderApi.js